/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 * @flow
 */

export const AGENT = 'AGENT';
export const PUBLIC = 'PUBLIC';
